import React, { useEffect, useState } from 'react';
import api from '../api';
import getAzureSasToken from '../../utils/azureSasToken';

const ImageViewer = ({ fileId, idRede }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_33;
  const azureSasToken = getAzureSasToken();
  const [imageUrl, setImageUrl] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl;

    const isAbsoluteHttpUrl = (value) => /^https?:\/\//i.test(value || '');
    const apiBaseNormalized = `/${String(apiUrl || '').replace(/^\/+|\/+$/g, '')}`;
    const getViewableBlobUrl = (url) => {
      if (!url) return '';
      if (url.includes('blob.core.windows.net') && !url.includes('?') && azureSasToken) {
        return `${url}${azureSasToken}`;
      }
      return url;
    };

    const fetchImage = async () => {
      try {
        setError(false);

        if (isAbsoluteHttpUrl(fileId)) {
          setImageUrl(getViewableBlobUrl(fileId));
          return;
        }

        const candidateUrls = [
          `${apiBaseNormalized}/${fileId}?id_rede=${idRede}`,
          `${apiBaseNormalized}/view/${fileId}?id_rede=${idRede}`,
        ];

        let imageBlob = null;
        let lastError = null;
        for (const url of candidateUrls) {
          try {
            const response = await api.get(url, { responseType: 'blob' });
            imageBlob = response.data;
            break;
          } catch (requestError) {
            lastError = requestError;
          }
        }

        if (!imageBlob) {
          throw lastError || new Error('Falha ao carregar imagem.');
        }

        objectUrl = URL.createObjectURL(imageBlob);
        setImageUrl(objectUrl);
      } catch (err) {
        console.error('Erro ao carregar imagem:', err);
        setError(true);
      }
    };

    fetchImage();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [fileId, idRede, apiUrl, azureSasToken]);

  if (error) {
    return <p>Erro ao carregar a imagem ou imagem não encontrada.</p>;
  }

  return (
    <div>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={`Imagem ${fileId}`}
          style={{ width: '200px', height: 'auto' }}
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/300?text=Imagem+não+encontrada';
            e.target.alt = 'Imagem não encontrada';
          }}
        />
      ) : (
        <p>Carregando imagem...</p>
      )}
    </div>
  );
};

export default ImageViewer;
